import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initPixel, trackPageView, onConsentChange } from "../lib/pixel";

export const MetaPixel = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initPixel();
    trackPageView(pathname);
  }, [pathname]);

  useEffect(() => onConsentChange((v) => { if (v === "granted") trackPageView(window.location.pathname); }), []);

  return null;
};
